import { Component } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    standalone: false,
})
export class LoadingSpinnerComponent {}
